<app-modal-header [hasClose]='true' [title]="'Recuperar Senha'" (handleClose)="close()"></app-modal-header>

<mat-dialog-content class="content-dialog">

  <form class="not-apply-padding" [formGroup]="forgotPasswordForm">
    <div id="text" class="primary-text">
      Para realizar a alteração de senha e voltar a ter acesso, preencha os campos abaixo:
    </div>

    <mat-form-field>
      <input type="text" [textMask]="{mask: mask.cpf}" formControlName="field_0_cpf" matInput placeholder="CPF">

      @if (forgotPasswordForm.controls['field_0_cpf'].hasError('required') &&
        forgotPasswordForm.controls['field_0_cpf'].touched) {
        <mat-error>
          Campo obrigatório
        </mat-error>
      }

      @if (!forgotPasswordForm.controls['field_0_cpf'].hasError('required') &&
        !forgotPasswordForm.controls['field_0_cpf'].valid &&
        forgotPasswordForm.controls['field_0_cpf'].touched) {
        <mat-error>
          Cpf inválido
        </mat-error>
      }
    </mat-form-field>



    <mat-form-field>
      <input type="text" [textMask]="{mask: mask.date}" formControlName="field_1_birthday" matInput placeholder="Data de Nascimento">

      @if (forgotPasswordForm.controls['field_1_birthday'].hasError('required') && forgotPasswordForm.controls['field_1_birthday'].touched) {
        <mat-error>
          Campo obrigatório
        </mat-error>
      }
    </mat-form-field>


    @if (!isContinuosIntegration()) {
      <div>
        <re-captcha class="captcha" language="pt-BR" (resolved)="handleCorrectCaptcha($event)"
        siteKey="6Le7EXMUAAAAAEvNpc6qtRMbccxWB2rTGIvPytoz"></re-captcha>
      </div>
    }

    <div style="margin: 10px 0px;">
      <p style="color: red;">
        Atenção: Caso não receba o e-mail de recuperação de senha nos próximos 10 minutos, verifique o SPAM ou Lixo Eletrônico.
      </p>
    </div>
  </form>

</mat-dialog-content>

<div class="modal-footer">
  @if (isLoading) {
    <div>
      <mat-spinner diameter="30"></mat-spinner>
    </div>
  }
  @if (!generatedPassword && !errorMsg && !isLoading) {
    <button type="button" mat-raised-button color="accent" [disabled]="!forgotPasswordForm.valid" (click)="forgotPassword()">
      Recuperar Senha
    </button>
  }

  @if (errorMsg) {
    <div class="flex">
      <p class="new-password-failed">{{errorMsg}}<i class="password"></i></p>
      <button id="modalApplyBtn" type="button" mat-raised-button color="accent" (click)="selfRegister()">
        AUTOCADASTRO
      </button>
    </div>
  }
</div>
